<template>
  <div class="container address" :data-corp-id="corpId">
    
     <ul>
       <li class="address_item" v-for="item in address"  @click="choiceAddress(item)">
        <div class="info_wrap">
          <i class="address_icon"></i>
          <div class="address_info_wrap">
            <div class="user_info">
             <div class="name">收货人：{{item.consignee}}</div>
             <div class="phone">{{item.mobile}}</div>
           </div>
            <p class="address_info">{{item.province}} {{item.city}} {{item.district}} {{item.address}}</p>
          </div>
          <i class="address_right"></i>
         </div>
         <div class="opctions">
            <label  class="check-box" :class="{checked:item.isDefault}" @click.stop="choiceDefaultAddress(item)">
               <i></i>
               <span class="default">默认地址</span>
            </label>
            <div class="btn_wrap">
              <a href="javascript:;" @click.stop="editAddress(item)">
              编辑
            </a>
            <a href="javascript:;" class="btn_del" @click.stop="todelAddress(item.addressId)">删除</a>
            </div>
         </div>
       </li>
     </ul>
     <div class="btn-wrap">
       
        <router-link class="btn add-address" :to="{ path: '/address/add' }">新增收货地址
            </router-link>
     </div>
     <x-dialog v-model="sureDialog" class="dialog-pop" :scroll="false">
        <div class="content-wrap">
           <p>确定要删除该地址吗？</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="sureDialog=false">取消</a>
          <a href="javascript:;" class="btn-txt" @click="delAddress">确定</a>
        </div>
      </x-dialog>
      <x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
        <div class="content-wrap">
           <p>{{tipText}}</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="tipDialog=false">知道啦</a>
        </div>
      </x-dialog>
      <home :ishome=0></home>
  </div>
</template>
<script>
import aghm from "../../api/aghm.js";
import  XDialog  from 'vux/src/components/x-dialog/index.vue'

import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
export default {
  data () {
    return {
     	sureDialog:false,
      updating: false,
      loading:true,
      delId:'',
      tipDialog:false,
      tipText:''
    }
  },
  components:{
    XDialog,
    home
  },
  computed:{ 
    orderId() {
      return this.$route.query.orderId
    },  	 	 
  	...mapGetters({
      address:'getaddress',
      updateAddressStatus:'getupdateAddressStatus',
      addressBackUrl:'getaddressBackUrl',
      delAddressStatus:'getdelAddressStatus',
      getUserInfo: 'getUserInfo',
    }),
    corpId(){
      return this.getUserInfo.corpId || '';
    },

  },
  beforeRouteEnter (to, from, next) {
    next(vm=>{
      if(from.fullPath.indexOf('address')==-1&&from.fullPath.indexOf('welfare')!=-1){
        let back={
          name:from.name,
          fullPath:from.fullPath
        }
        vm.$store.dispatch('getAddressBack',back)
      }
      if(from.fullPath.indexOf('address')==-1&&from.fullPath.indexOf('aboutme')!=-1){
          vm.$store.dispatch('getAddressBack','')
      }
    })
  },
  watch:{
    address(cval){
      if(cval){
        this.loading=false
      }
    },
    updateAddressStatus(cval){
      let bcval=cval.split('&')[0]
      if(!bcval){
        this.tipText=cval;
        this.tipDialog=true;
      }else{
        window.location.reload();
      }
      
    },
    delAddressStatus(cval){
      let bcval=cval.split('&')[0]
      if(bcval){
        this.sureDialog=false;
        window.location.reload();
      }
    }
  },
 beforeDestroy() {
    // 组件销毁时恢复默认标题
    this.$store.commit('CORP_CUSTOMIZE_ATTR', {
      data: {
        key: 'page_title_default',
        value: ''
      }
    })
  },
  created(){
    this.$store.dispatch('loadAddress')
   
  },
  methods:{
    editAddress(data){
      this.$store.dispatch('getEditAddress',data)
      this.$router.push({
        name:'addressEdit',
        query:{
          addressId:data.addressId
        }
      })
    },
    todelAddress(data){
      this.delId=data
      this.sureDialog=true;
    },
    choiceAddress(data){
       let choiceId=data.addressId;

       if(this.orderId) {
        aghm.orderChangeAddress({
          orderId:this.orderId,
          addressId:data.addressId
        }).then((res) =>{
          if(res.data && res.data.errno == 0){
            this.$router.go(-1)
          }else{
            this.tipDialog = true;
            this.tipText = '更新失败';
          }
        },(error) =>{
            this.tipDialog = true;
            this.tipText = error || '网络异常，请稍后再试';
         })
      } else if(this.addressBackUrl){
        let query={addressId:choiceId}
        this.$router.push({
          path:this.addressBackUrl.fullPath,
          query:query
        })
      }
    },
    choiceDefaultAddress(data){
      let params=Object.assign({},data,{isDefault:1})
      this.$store.dispatch('doUpdateAddress',params)
    },
    delAddress(){
      this.$store.dispatch('delAddress',{addressId:this.delId})
    }
  },
  mounted(){
    console.log("route",this.addressBackUrl)
    this.$store.commit('CORP_CUSTOMIZE_ATTR', { 
        data: { 
          key: 'page_title_default', 
          value: '地址簿',
        } 
    })
  }
}
</script>